import _ from 'lodash';
import appHelpers from 'app/app-helpers';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import helpers from '../../helpers/contact-helpers';
import contactListTemplate from './contact-list.html';
import EditCategoryDialogController from '../manage-contact/edit-category-dialog/edit-category-dialog-controller';
import editCategoryDialogTemplate from '../manage-contact/edit-category-dialog/edit-category-dialog.html';
import EditContactDialogController from '../manage-contact/edit-contact-dialog/edit-contact-dialog-controller';
import editContactDialogTemplate from '../manage-contact/edit-contact-dialog/edit-contact-dialog.html';

const DIRTY_FORM = 'contactManagement';

const mapStateToThis = ({ session, config }) => {
  const { locale } = session;
  const { locales, googleMapsUrl } = config;

  return {
    locale,
    locales,
    googleMapsUrl,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications', 'gettextCatalog')
class ContactListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = DIRTY_FORM;
  }

  $onInit() {
    this.language = this.language || this.locale;
    this.contactDndTree = {
      accept: (sourceNodeScope, destNodesScope) => this.accept({ sourceNodeScope, destNodesScope }),
      dragMove: appHelpers.dragMove,
      orderChanged: () => {
        this.setDirtyForm(this.DIRTY_FORM, true);
      },
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  editContact(contact, exists = true) {
    this.locales.map((locale) => {
      if (!contact.fields[locale.code]) {
        contact.fields[locale.code] = {
          phone: [],
          email: [],
          mapCoordinates: '',
        };
      }
    });

    this.Notifications.showComplexDialog({
      template: editContactDialogTemplate,
      bindToController: true,
      controller: EditContactDialogController,
      resolve: {
        title: () => this.gettextCatalog.getString('Edit Contact'),
        language: () => this.language,
        contact: () => _.cloneDeep(contact),
        categories: () => this.contactList.groups,
        exists: () => exists,
      },
    }).result.then((result) => {
      this.setDirtyForm(this.DIRTY_FORM, true);
      this.contactList.groups = helpers.saveContact(this.contactList.groups, result.contact, exists, result.categoryChanged);
      if (result.contact.id === _.get(this, 'contactList.properties.default')) {
        this.updatePhone(result.contact.fields[this.language].phone[0]);
      }
    });
  }

  editCategory(category) {
    this.Notifications.showComplexDialog({
      template: editCategoryDialogTemplate,
      bindToController: true,
      controller: EditCategoryDialogController,
      resolve: {
        title: () => this.gettextCatalog.getString('Edit Category'),
        category: () => _.cloneDeep(category),
      },
    }).result.then((result) => {
      this.setDirtyForm(this.DIRTY_FORM, true);
      this.contactList.groups = helpers.saveCategory(this.contactList.groups, result.category, result.oldCategoryName);
      this.categories = this.contactList.groups;
    });
  }

  parseGoogleMapsUrl(contact) {
    if (!contact.fields[this.language]) {
      return '';
    }
    const addressLine1 = _.get(contact.fields, `[${this.language}].addressLine1`) || '';
    const addressLine2 = _.get(contact.fields, `[${this.language}].addressLine2`) || '';
    const addressLine3 = _.get(contact.fields, `[${this.language}].addressLine3`) || '';
    const address = `${addressLine1}${addressLine2 ? `+${addressLine2}` : ''}${addressLine3 ? `+${addressLine3}` : ''}`;
    const coords = _.get(contact.fields, `[${this.language}].mapCoordinates`) || '';

    return coords ? `${this.googleMapsUrl}place/${coords}` : `${this.googleMapsUrl}search/${address}`;
  }

  removeCategory(category) {
    this.setDirtyForm(this.DIRTY_FORM, true);
    this.contactList.groups = helpers.removeCategory(this.contactList.groups, category);
    this.categories = this.contactList.groups;
  }

  removeContact(contact, index) {
    this.setDirtyForm(this.DIRTY_FORM, true);
    this.contactList.groups = helpers.removeContact(this.contactList.groups, contact, index);
  }

  showMarker(contact) {
    const address = _.get(contact.fields, `[${this.language}].addressLine1`) || '';
    const coords = _.get(contact.fields, `[${this.language}].mapCoordinates`) || '';
    return address.length > 1 || coords.length > 1;
  }

  updatePhone(phone = {}) {
    this.setDirtyForm(this.DIRTY_FORM, true);
    this.contactList.properties.phone = phone.phone;
    this.contactList.properties.ext = phone.ext;
  }
}

export default class ContactListComponent {
  constructor() {
    this.template = contactListTemplate;
    this.controller = ContactListController;
    this.bindings = {
      language: '<',
      canEdit: '<',
      contactList: '<',
      accept: '&',
      onLanguageSelect: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/contact/components/contact-list/contact-list-component.js